/**
 * 输出格式化日志
 * 该模块提供了一个简单的日志记录器，支持不同的日志级别。
 */

// 获取当前时间，返回格式化的时间字符串
const getTime = (): string => {
  const date = new Date()
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // 月份是从0开始的
  const day = date.getDate().toString().padStart(2, '0')
  const hour = date.getHours().toString().padStart(2, '0')
  const min = date.getMinutes().toString().padStart(2, '0')
  const sec = date.getSeconds().toString().padStart(2, '0')
  const ms = date.getMilliseconds().toString().padStart(3, '0') // 确保毫秒数是三位数

  return `[${year}-${month}-${day} ${hour}:${min}:${sec}.${ms}]`
}

// 定义日志级别的枚举
export enum LOG_LEVEL {
  info = 'INFO',
  log = 'LOG',
  error = 'ERROR',
  warn = 'WARN',
  debug = 'DEBUG',
}

// 输出日志，根据不同的日志级别调用不同的console方法
const echo = (logLevel: LOG_LEVEL, args: any[] = []) => {
  const prefix = `Realsee Live ${getTime()} <${logLevel}> ` // 日志前缀，包含时间和日志级别
  switch (logLevel) {
    case LOG_LEVEL.info:
      console.info(prefix, ...args) // 输出信息级别的日志
      break
    case LOG_LEVEL.error:
      console.error(prefix, ...args) // 输出错误级别的日志
      break
    case LOG_LEVEL.warn:
      console.warn(prefix, ...args) // 输出警告级别的日志
      break
    case LOG_LEVEL.debug:
      console.debug(prefix, ...args) // 输出调试级别的日志
      break
    default:
      console.log(prefix, ...args) // 默认输出普通日志
  }
}

// 日志记录器对象，提供不同级别的日志方法
const logger = {
  log: (...args: any[]) => echo(LOG_LEVEL.log, args), // 普通日志
  info: (...args: any[]) => echo(LOG_LEVEL.info, args), // 信息日志
  error: (...args: any[]) => echo(LOG_LEVEL.error, args), // 错误日志
  warn: (...args: any[]) => echo(LOG_LEVEL.warn, args), // 警告日志
  debug: (...args: any[]) => echo(LOG_LEVEL.debug, args), // 调试日志
}

export default logger // 导出日志记录器
